import React from 'react';

import Breadcrumb from './breadcrumb';

type Props = {
  style?: any;
  textStyle?: any;
  linkStyle?: any;
  volumeName: string;
  prefix: string;
  path: string;
  extra?: string;
};
export default function BreadcrumbPath(props: Props) {
  const { prefix, path, extra, ...other } = props;

  const parts = path.split('/').filter((p) => p.length > 0);
  if (extra) {
    parts.push(extra);
  }
  const list: any[] = [{ url: prefix, text: props.volumeName }];
  let url = prefix;
  parts.forEach((part, i) => {
    url += part + '/';
    if (i + 1 === parts.length) {
      list.push(part);
    } else {
      list.push({ url, text: part });
    }
  });

  return <Breadcrumb {...other} list={list} />;
}
